import { cn } from '@/lib/cn';

interface LogoProps {
  className?: string;
  size?: number;
  withWordmark?: boolean;
}

export function Logo({ className, size = 28, withWordmark = true }: LogoProps) {
  return (
    <div className={cn('inline-flex items-center gap-2', className)}>
      <span
        className="grid place-items-center overflow-hidden rounded-md bg-primary text-primary-foreground shadow-soft"
        style={{ width: size, height: size }}
        aria-hidden
      >
        <span
          className="font-display font-bold leading-none"
          style={{ fontSize: Math.round(size * 0.62), letterSpacing: -1 }}
        >
          F
        </span>
      </span>
      {withWordmark ? (
        <span className="flex items-baseline gap-1">
          <span className="font-display text-base font-bold tracking-tight">Fasto</span>
          <span className="font-display text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
            BI
          </span>
        </span>
      ) : null}
    </div>
  );
}
